import React from "react";

export const HelpDeskTickets = React.lazy(() => import("./HelpDeskTickets"));

export const TicketDetails = React.lazy(() => import("./TicketDetails"));
export const ListAllTicktes = React.lazy(() => import("./ListAllTicktes"));
export const ListAllAssignedTicktes = React.lazy(() => import("./ListAllAssignedTicktes"));
export const AdminListAllTickets = React.lazy(() =>
  import("./AdminListAllTickets")
);
export const TaskUnlock = React.lazy(() => import("./TaskUnlock"));
export const HelpDeskSettings = React.lazy(() => import("./HelpDeskSettings"));